var _excluded = ["children", "className"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from "../Button/Button";
import Icon from "../Icon/Icon";

var HasManyFieldsAdd = function HasManyFieldsAdd(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = classNames('border-0', className);
  return /*#__PURE__*/React.createElement(Button, _extends({
    color: "success",
    block: true,
    outline: true
  }, props, {
    className: classes
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "plus-circle",
    className: "me-2"
  }), /*#__PURE__*/React.createElement("span", null, children));
};

HasManyFieldsAdd.displayName = "HasManyFieldsAdd";
HasManyFieldsAdd.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool
};
HasManyFieldsAdd.displayName = 'HasManyFieldsAdd';
export default HasManyFieldsAdd;